  <template>
  <div class="current-company-selector">
    <span class="current-company-selector-label">Logado em:</span>
    <multiselect v-model="currentCompany" id="companies" class="current-company-selector-multiselect"
      placeholder="Procure pela razão social"
      :options="companies"
      track-by="public_key"
      :internal-search="false"
      :allow-empty="false"
      open-direction="bottom"
      :showLabels="false"
      :loading="loading"
      @open="loadCompanies(false)"
      @search-change="onSearch"
      @select="onSelect"
      @input="onInput">

      <span slot="option" slot-scope="{ option }" :class="{inactive: option.status != '1'}">{{option.name }}</span>
      <span slot="singleLabel" slot-scope="{ option }">{{ option.name }}</span>
      <span slot="noResult">Nenhuma empresa encontrada.</span>
    </multiselect>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { toast } from '../../mixins/toast'
import { errorMessage } from '../../mixins/error-message'
import { httpService } from '../../providers/http-service'

import Multiselect from 'vue-multiselect'

export default {
  mixins: [ toast, errorMessage ],
  components: { Multiselect },

  data() {
    return {
      companyList: [],
      companies: [],
      currentCompany: null,
      previousCompany: null,
      loading: false
    }
  },

  methods: {

    ...mapActions(['setCompany']),
    ...mapGetters(['getCompany', 'getPermissions']),

    onSearch(search) {
      this.companies = this.companyList.filter(el => {
        return el.name.match(new RegExp(search, 'i'))
      })
    },

    onSelect(selected) {
      if (selected.status != '1') {
        this.show_toast('warning', 'Atenção!', `Empresa ${selected.name} com situação pendente ou inativa!`)
      } else {
        this.previousCompany = selected
        this.currentCompany = selected
        this.setCompany(selected)
        this.show_toast('success', '', `Logado em ${selected.fantasy || selected.name} com sucesso!`)
        setTimeout(() => location.reload(), 1000)
      }
    },

    onInput(selected, event) {
      if(selected.status != '1') {
        this.currentCompany = this.previousCompany;
      }
    },

    loadCompanies(useDefault = false) {
      if(this.companyList.length === 0) {
        this.loading = true
        this.getCompanies().then(res => {
          if(res.length !== 0) {
            this.companyList = res
            this.companies = this.companyList
            const activeCompanies = this.companies.filter(cmp => cmp.status == '1')
            if (activeCompanies.length === 0) {
              this.show_toast('warning', 'Atenção!', `Nenhuma empresa ativa disponível!`)
            } else {
              if(useDefault) this.onSelect(activeCompanies[0])
            }
          } else {
            this.show_toast('warning', 'Atenção!', `Você ainda não possui acesso a nenhuma empresa!`)
          }

        })
        .catch(err => this.showErrorMessage({ err: err }))
        .finally(() => this.loading = false)
      }
    },

    getCompanies() {
      // Carrega todos os produtos e suas permissões.
      return httpService.getProductsList()
        .then(res => res.data)
        .then(products => Promise.all(
          products.map(prod => {
            return httpService.getProductPermissions(prod.public_key)
              .then(res => { prod.permissions = res.data.map(perm => perm.public_key); return prod })
            })
          )
        )
        .then(prods => {
          const companies = this.getPermissions()

          // Filtra quais empresas o usuário tem pelo menos uma permissão.
          const myCompanies = companies.filter(cmp => {
            let hasAtLeastOnePermission = false
            cmp.products.forEach(prod => {
              const allFunctionalities = prods.find(p => p.public_key === prod.public_key).permissions
              if(allFunctionalities > prod.functionalities) hasAtLeastOnePermission = true
            });
            return hasAtLeastOnePermission
          });

          return myCompanies
        });
    }

  },

  mounted() {
    this.currentCompany = this.getCompany()
    if(this.$route.query.cp_public_key && (!this.currentCompany || this.currentCompany.public_key !== this.$route.query.cp_public_key)) {
      this.onSelect({ public_key: this.$route.query.cp_public_key, id: this.$route.query.cp_id, fantasy: this.$route.query.cp_fantasy, name: this.$route.query.cp_name, status: this.$route.query.cp_status })
    }
    if(!this.currentCompany) this.loadCompanies(true)
  }

}
</script>

<style>
  .current-company-selector {
    width: 300px;
    line-height: 36px;
    display: flex;
    flex-wrap: wrap;
  }

  .current-company-selector-label {
    flex-basis: 25%;
    max-width: 25%;
  }

  .current-company-selector-multiselect {
    flex-basis: 75%;
    max-width: 75%;
    font-size: 12px;
  }

  .current-company-selector-multiselect .multiselect__single { font-size: 12px; }
  .current-company-selector-multiselect .multiselect__element { display: block; }
  .current-company-selector-multiselect .multiselect__content-wrapper { overflow-x: hidden; }
  .current-company-selector-multiselect .multiselect__option {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 220px;
    display: inline-block;
  }

  .inactive { color: #bb2626; }
  .multiselect__element:hover .inactive { color: #ffdddd; }
</style>



// WEBPACK FOOTER //
// src/components/layout/CurrentCompanySelector.vue